export default __webpack_public_path__ + "static/media/login.91ba5144.svg";